//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as ActivityActions from './actions';

import { logToSentry } from "utils/networkErrorUtils";
import { has } from 'lodash'
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- List books ----------------


//  -- List books ----------------
export const handleListBookUnits = () => async (dispatch) => {
    await dispatch(ActivityActions.listBookUnits());
    try {
        let bookUnits = [];
        const booksUnitRDS = await apis.get('bookUnits', `/bookUnitsList`);
        if (Array.isArray(booksUnitRDS) && booksUnitRDS.length > 0) {
            bookUnits = booksUnitRDS
        }
        await dispatch(ActivityActions.listBookUnitsSuccess(bookUnits));
        return bookUnits;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing book units',
                error,
                module: 'BOOKS_UNITS',
                operation: 'LIST_BOOK_USER'
            });
        }
        await dispatch(ActivityActions.listBookUnitsFail(error));
    }
};

export const handleUpdateUnits = (id, unit) => async (dispatch) => {
    await dispatch(ActivityActions.updateBookUnits());
    try {
        const booksUnitRDS = await apis.put('bookUnits', `/update/${id}`, {
            body: unit
        });
        if (has(booksUnitRDS, "id")) {
            await dispatch(ActivityActions.updateBookUnitsSuccess(booksUnitRDS));
        }

        return booksUnitRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating book units',
                error,
                module: 'BOOKS_UNITS',
                operation: 'UPDATE_BOOK_USER'
            });
        }
        await dispatch(ActivityActions.updateBookUnitsFail(error));
    }


}

// schoology course map
export const handleListSchoologyCources = () => async (dispatch) => {
    try {
        const booksUnitRDS = await apis.get('bookUnits', `/list_schoology_bookmap`);
        return booksUnitRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing schoology course map',
                error,
                module: 'BOOKS_UNITS',
                operation: 'LIST_STUDENT_CLASS_MESSAGE'
            });
        }
    }
}
export const handleListSchoologyCourcesByDistId =async  (district_id,type) =>{
    try {
        const courses_for_district = await apis.post('bookUnits', `/list_schoology_bookmap_by_dist_id`,{
            body:{
                district_id:district_id,
                type:type
            }
        });
        return courses_for_district;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing schoology course map by district id',
                error,
                module: 'BOOKS_UNITS',
                operation: 'LIST_STUDENT_CLASS_MESSAGE_BOOK_DATA_INSTRUCTION'
            });
        }
    }
}
export const handleDeleteSchoologyCources =async  (id) =>{
    try {
        const courses_for_district = await apis.del('bookUnits', `/delete_schoology_course/${id}`);
        return courses_for_district;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'deleting schoology course',
                error,
                module: 'BOOKS_UNITS',
                operation: 'DELETE_STUDENT_CLASS'
            });
        }
    }
}
export const handleUpdateSchoologyCources = (data) => async (dispatch) => {
    try {
        const booksUnitRDS = await apis.put('bookUnits', `/update_schoology_coursemap`, {
            body: data
        });
        return booksUnitRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating schoology course',
                error,
                module: 'BOOKS_UNITS',
                operation: 'UPDATE_STUDENT_CLASS'
            });
        }
    }
}
//canvas course map
export const handleListCanvasCourse = () => async (dispatch) => {
    try {
        const booksUnitRDS = await apis.get('bookUnits', `/list_canvas_bookmap`);
        return booksUnitRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing canvas course',
                error,
                module: 'BOOKS_UNITS',
                operation: 'LIST_CLASS_CLASS'
            });
        }
    }
}
export const handleUpdateCanvasCources = (data) => async (dispatch) => {
    try {
        const booksUnitRDS = await apis.put('bookUnits', `/update_canvas_coursemap`, {
            body: data
        });
        return booksUnitRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating canvas course',
                error,
                module: 'BOOKS_UNITS',
                operation: 'UPDATE_CLASS_CLASS'
            });
        }
    }
}
//clever course map
export const handleListCleverCourse = () => async (dispatch) => {
    try {
        const booksUnitRDS = await apis.get('bookUnits', `/list_clever_bookmap`);
        return booksUnitRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing clever course',
                error,
                module: 'BOOKS_UNITS',
                operation: 'LIST_CLASS_CLASS'
            });
        }
    }
}
export const handleUpdateCleverCources = (data) => async (dispatch) => {
    try {
        const booksUnitRDS = await apis.put('bookUnits', `/update_clever_coursemap`, {
            body: data
        });
        return booksUnitRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating clever course',
                error,
                module: 'BOOKS_UNITS',
                operation: 'UPDATE_CLASS_CLASS'
            });
        }
    }
}
// google course map
export const handleListGoogleCourse = () => async (dispatch) => {
    try {
        const data = await apis.get('bookUnits', `/list_google_bookmap`);
        if(data&&data.success){ 
            dispatch(ActivityActions.setGoogleCourseMap(data.data));
        }
        return data;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing google course',
                error,
                module: 'BOOKS_UNITS',
                operation: 'LIST_GROUP_CLASS'
            });
        }
    }
}
export const handleUpdateGoogleCources = (data) => async (dispatch) => {
    try {
        const booksUnitRDS = await apis.put('bookUnits', `/update_google_coursemap`, {
            body: data
        });
        return booksUnitRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating google course',
                error,
                module: 'BOOKS_UNITS',
                operation: 'UPDATE_GROUP_CLASS'
            });
        }
    }
}
// class link course map
export const handleListClasslinkCourse = () => async (dispatch) => {
    try {
        const booksUnitRDS = await apis.get('bookUnits', `/list_classlink_bookmap`);
        return booksUnitRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'listing classlink course',
                error,
                module: 'BOOKS_UNITS',
                operation: 'LIST_CLASS_CLASS'
            });
        }
    }
}
export const handleUpdateClasslinkCources = (data) => async (dispatch) => {
    try {
        const booksUnitRDS = await apis.put('bookUnits', `/update_classlink_coursemap`, {
            body: data
        });
        return booksUnitRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'updating classlink course',
                error,
                module: 'BOOKS_UNITS',
                operation: 'UPDATE_CLASS_CLASS'
            });
        }
    }
}
export const handleGetClasslinkCourseByDist = async (orgId) =>  {
    try {
        const booksUnitRDS = await apis.get('bookUnits', `/get_classlink_dist_bookmap/${orgId}`);
        return booksUnitRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting classlink course by district',
                error,
                module: 'BOOKS_UNITS',
                operation: 'GET_CLASS_CLASS_BOOK_DATA'
            });
        }
    }
}
export const handleGetCanvasCourseByDist = async(orgId) =>  {
    try {
        const booksUnitRDS = await apis.get('bookUnits', `/get_canvas_dist_bookmap/${orgId}`);
        return booksUnitRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting canvas course by district',
                error,
                module: 'BOOKS_UNITS',
                operation: 'GET_CLASS_CLASS_BOOK_DATA'
            });
        }
    }
}
export const handleGetCleverCourseByDist =async (orgId) =>  {
    try {
        const booksUnitRDS = await apis.get('bookUnits', `/get_clever_dist_bookmap/${orgId}`);
        return booksUnitRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: 'getting clever course by district',
                error,
                module: 'BOOKS_UNITS',
                operation: 'GET_CLASS_CLASS_BOOK_DATA'
            });
        }
    }
}

